/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {ResetPassword} from './components/ResetPassword'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        background: `linear-gradient(180deg, rgba(225,254,250,1) 0%, rgba(255,255,255,1) 100%)`,
      }}
      >
      
      {/*
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
      }}
    */}
    
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid mt-10 p-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='#' className='mb-7'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/prospect-logo-icon.png')} className='h-150px' />
        </a>
        {/* end::Logo */}
        <div className='row flex-center'>
          <h2 className='p-5 text-gray-600'>Sign in to Prospect App</h2>
        </div>
        {/* begin::Wrapper */}
        <div className='w-100 w-md-500px w-lg-500px bg-white shadow-sm p-10 p-lg-15 mx-auto border border-prgrey rounded-xl'>
          <Switch>
            <Route path='/auth/login' component={Login} />
            <Route path='/auth/registration' component={Registration} />
            <Route path='/auth/forgot-password' component={ForgotPassword} />
            <Route path='/auth/password/reset/:resetToken/:email' component={ResetPassword} />
            <Redirect from='/auth' exact={true} to='/auth/login' />
            <Redirect to='/auth/login' />
          </Switch>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid1 p-10 pb-lg-20'>
                        <img alt='Logo' src={toAbsoluteUrl('/media/logos/propertyawards.svg')} className='h-75px' />
                        <h4 className='text-gray-600 p-10'>Best Sales & Lettings agent winner<br></br> At the UK Property Awards 2022-2023</h4>
                    </div>
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <a href='#' className='text-muted text-hover-primary px-2'>
            About
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact Us
          </a>
        </div>
      </div>
      <div className='d-flex flex-center flex-column-auto'>
      <div className="row d-flex align-items-center fw-bold fs-6">
        <p>
        Copyright &copy; {new Date().getFullYear()} Prospect. Version 1.0. All Rights Reserved.
        </p>
      </div>
      </div>
      {/* end::Footer */}
    </div>
  )
}
